<template>
    <div class="ele-body">
        <el-card shadow="never">
            <el-steps :active="active_tab" finish-status="success" simple style="margin-top: 20px;">
              <el-step title="选择分类" ></el-step>
              <el-step title="商品信息" ></el-step>
            </el-steps>
            <div style="width: 100%;height: 30px;"></div>
            <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="200px" class="demo-ruleForm">
                <div v-show="active_tab == 0">
                    <el-form-item label="店铺:" prop="shop_id">
                        <el-select v-model="editForm.shop_id" filterable placeholder="请选择" @change="(e)=>shopChange(e)">
                            <el-option v-for="item in store_shop_management_list" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="行业选择:" prop="industry_id">
                        <el-cascader-panel v-model="editForm.industry_id" :options="options" :props="{value:'id',label:'name'}"></el-cascader-panel>
                    </el-form-item>
                    <el-form-item label="" prop="sort">
                        <el-button @click="nextTo">下一步</el-button>
                        <!-- <el-button type="primary" @click="save">保存</el-button> -->
                    </el-form-item>
                </div>
                <div v-show="active_tab == 1">
                    <el-form-item label="商品分类:">
                        <el-cascader-panel v-model="temp_goods_cat_id" :options="store_goods_cat_list_first" :props="{value:'id',label:'name',multiple:true,truemexpandTrigger:'hover'}"></el-cascader-panel>
                        <!-- <el-select v-model="goods_cat_id" filterable placeholder="请选择" @change="selectGoodsCatId">
                            <el-option v-for="item in " :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select> -->
                    </el-form-item>
                    <el-form-item label="商品名称:" prop="name">
                        <el-input v-model="editForm.name" placeholder="请输入商品名称" clearable />
                    </el-form-item>
                    <el-form-item label="商品标语:" prop="brief">
                        <el-input v-model="editForm.brief" placeholder="请输入商品标语" clearable />
                    </el-form-item>
                    <el-form-item label="关键字搜索:" prop="keyword">
                        <el-input v-model="editForm.keyword" placeholder="请输入关键字搜索,逗号(,)隔开" clearable />
                    </el-form-item>
                    
                    <el-form-item label="缩略图:" prop="thumbnail_pic">
                        <ele-uploadimage :limit="1" v-model="editForm.thumbnail_pic"></ele-uploadimage>
                    </el-form-item>
                    <el-form-item label="轮播图:" prop="images">
                        <ele-uploadimage :limit="9" v-model="editForm.images"></ele-uploadimage>
                    </el-form-item>
                    <el-form-item label="商品视频:" prop="video">
                        <ele-upload-resource-other :limit="1" v-model="editForm.video"></ele-upload-resource-other>
                    </el-form-item>
                    <el-form-item label="开启面议:" prop="face_status">
                        <el-radio-group v-model="editForm.face_status">
                            <el-radio label="2">关闭</el-radio>
                            <el-radio label="1">开启</el-radio>
                          </el-radio-group>
                       <!-- <el-input-number v-model="editForm.price" controls-position="right" :min="0" :controls="false"
                            :precision="2" class="ele-fluid ele-text-left" placeholder="请输入销售价" clearable /> -->
                    </el-form-item>
                    <el-form-item label="商品参数:" prop="parameter">
                        <el-button type="primary" @click="addParameter">添加参数</el-button>
                        <el-form-item label="">
                            <el-table ref="multipleTable" :data="editForm.parameter" stripe tooltip-effect="dark"
                                style="width: 100%;margin-top:1%;" border>
                                <el-table-column prop="name" label="标题">
                                    <template slot-scope="{row}">
                                        <el-input v-model="row.name" placeholder="输入标题"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="value" label="属性值">
                                    <template slot-scope="{row}">
                                        <el-input  v-model="row.value" placeholder="输入属性值"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="image" label="操作">
                                    <template slot-scope="{row,index,$index}">
                                         <el-button type="danger" icon="el-icon-delete" circle @click="deleteParameter($index)"></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                    </el-form-item>
                    
                   
                    <el-form-item label="成本价:" prop="costprice">
                        <el-input-number v-model="editForm.costprice" controls-position="right" :min="0" :controls="false"
                            :precision="2" class="ele-fluid ele-text-left" placeholder="请输入成本价" clearable />
                    </el-form-item>
                    <el-form-item label="市场价:" prop="mktprice">
                        <el-input-number v-model="editForm.mktprice" controls-position="right" :min="0" :controls="false"
                            :precision="2" class="ele-fluid ele-text-left" placeholder="请输入市场价" clearable />
                    </el-form-item>
                   <el-form-item label="销售价:" prop="price">
                       <el-input-number v-model="editForm.price" controls-position="right" :min="0" :controls="false"
                           :precision="2" class="ele-fluid ele-text-left" placeholder="请输入销售价" clearable />
                   </el-form-item> 
                    
                    <el-form-item label="单位:" prop="unit">
                        <el-select v-model="editForm.unit" filterable placeholder="请选择单位" @change="changeFormat">
                            <el-option label="无单位" value=""></el-option>
                            <el-option v-for="(item,index) in store_goods_unit_list" :key="index" :label="item.title" :value="item.title">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="详情:" prop="info">
                        <tinymce-editor v-model="editForm.info" :init="initEditor" />
                    </el-form-item>
                    
                    <el-form-item label="库存:" prop="stock">
                        <el-input-number v-model="editForm.stock" controls-position="right" :controls="false" :precision="0"
                            class="ele-fluid ele-text-left" placeholder="请输入库存" clearable />
                    </el-form-item>
                    <el-form-item label="销量:" prop="sales_num">
                        <el-input-number v-model="editForm.sales_num" controls-position="right" :controls="false" :precision="0"
                            class="ele-fluid ele-text-left" placeholder="请输入销量" clearable />
                    </el-form-item>
                    <el-form-item label="库存扣减方式:" prop="stock_reduce">
                        <el-radio-group v-model="editForm.stock_reduce">
                            <el-radio label="1">买家拍下减库存</el-radio>
                            <el-radio label="2">买家付款减库存</el-radio>
                          </el-radio-group>
                    </el-form-item>
                    <el-form-item label="起订数量:" prop="initial">
                        <el-input-number v-model="editForm.initial" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入起订数量" clearable />
                    </el-form-item>
                    
                    <!-- 规格-->
                    <el-form-item label="规格属性:" prop="mktprice">
                        <el-select v-model="editForm.format_id" filterable placeholder="请选择规格" @change="changeFormat">
                            <el-option label="" value=""></el-option>
                            <el-option v-for="(item,index) in formatInfo" :key="index" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商品规格：" v-if="formatClass">
                        <div class="ikz-sku" v-for="(item,index) in formatClass" :key="index">
                            <el-col :span="2">
                                {{item.name}}：
                            </el-col>
                            <el-col :span="12">
                                <el-checkbox-group class="ikz-checkbox-box" v-model="checked_sku_info">
                                    <div class="ikz-checkbox-box-item" v-for="(it,ix) in item.children" :key="ix">
                                        <el-checkbox :label="it.name"
                                            @change="checked=>handleCheckedCitiesChange(checked,index,it)">{{it.name}}
                                        </el-checkbox>
                                    </div>
                                </el-checkbox-group>
                            </el-col>
                        </div>
                    </el-form-item>
                    <el-form-item label="">
                        <el-table ref="multipleTable" :data="tableColumnList.tableBodyList" stripe tooltip-effect="dark"
                            style="width: 100%;margin-top:1%;" border>
                            <el-table-column :label="item.propName" :property="item.prop"
                                v-for="item in tableColumnList.tableHeaderList" :key="item.prop" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row[scope.column.property] }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sku_price" label="销售价格">
                                <template slot-scope="{row}">
                                    <el-input type="number" v-model="row.sku_price" placeholder="输入价格"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sku_costprice" label="成本价格">
                                <template slot-scope="{row}">
                                    <el-input type="number" v-model="row.sku_costprice" placeholder="输入成本价格"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sku_mktprice" label="市场价格">
                                <template slot-scope="{row}">
                                    <el-input type="number" v-model="row.sku_mktprice" placeholder="输入市场价格"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sku_stock" label="商品库存">
                                <template slot-scope="{row}">
                                    <el-input type="number" v-model="row.sku_stock" placeholder="输入库存"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sku_initial" label="起购数量">
                                <template slot-scope="{row}">
                                    <el-input type="number" v-model="row.sku_initial" placeholder="起购数量"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="image" label="商品图片">
                                <template slot-scope="{row}">
                                    <ele-uploadimage :limit="1" v-model="row.image"></ele-uploadimage>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                    <el-form-item label="配送方式:" prop="fare_type">
                        <el-checkbox-group v-model="editForm.fare_type" @change="fareTypeChange">
                          <el-checkbox label="1">物流配送</el-checkbox>
                          <el-checkbox label="2">商家配送</el-checkbox>
                          <el-checkbox label="3">到店自提</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item v-if="fare_status" label="物流模板:" prop="fare_id">
                        <el-select v-model="editForm.fare_id" filterable placeholder="请选择" @change="selectGoodsCatId">
                            <el-option v-for="item in logistics_fare_list" :key="item.id" :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="售后服务:" prop="after_service">
                        <el-checkbox-group v-model="editForm.after_service">
                          <el-checkbox label="1">提供发票</el-checkbox>
                          <el-checkbox label="2">保修服务</el-checkbox>
                          <el-checkbox label="3">退换货承诺</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="评论开启关闭:" prop="comment_status">
                        <el-radio-group v-model="editForm.comment_status">
                            <el-radio label="1">开启</el-radio>
                            <el-radio label="2">关闭</el-radio>
                          </el-radio-group>
                    </el-form-item>
                    <el-form-item label="排序:" prop="sort">
                        <el-input-number v-model="editForm.sort" controls-position="right" :controls="false" :precision="0"
                            class="ele-fluid ele-text-left" placeholder="请输入排序" clearable />
                    </el-form-item>
                    <el-form-item label="" prop="sort">
                        <el-button @click="active_tab = 0">上一步</el-button>
                        <el-button type="primary" @click="save">保存</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </el-card>
    </div>
</template>

<script>
    import {
        mapGetters
    } from "vuex";

    import EleUploadimage from '@/components/EleUploadimage'
    import TinymceEditor from '@/components/TinymceEditor'
    import EleUploadResourceOther from '@/components/EleUploadResourceOther'
    export default {
        name: "SysstoreGoods",
        components: {
            EleUploadimage,
            TinymceEditor,
            EleUploadResourceOther
        },
        data() {
            return {
                fare_status:true,
                active_tab:0,
                options:[],//行业
                goods_cat_id: '',
                tableColumnList: {
                    // tableHeaderList: [],
                    // tableBodyList: []
                    // inventory: ''
                },
                privateGoodsItem: [
                    // {
                    //     privateSpecName: '', //规格名
                    //     dynamicTags: [], //规格值数组
                    //     inputVisible: false,
                    //     inputValue: ''
                    // },
                ],
                checked_sku_info: [],
                table: {
                    url: '/store/storeGoods/index',
                    where: {
                        "thumbnail_pic": [],
                        "images": []
                    }
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                editForm: {
                    "thumbnail_pic": [],
                    "images": [],
                    fare_type:['1','2','3'],
                    stock_reduce:'1',
                    after_service:['1','2','3'],
                    comment_status:'1',
                    parameter:[],//参数数据.
                    face_status:'2',
                    unit:''
                }, // 表单数据
                editFormTemp: {
                    "thumbnail_pic": [],
                    "images": []
                },
                admin_list: [],
                user_list: [],
                search_show: false,
                store_goods_cat_list: [],
                store_shop_management_list: [],
                store_goods_cat_list_first: [],
                logistics_fare_list:[],//物流信息
                formatInfo: {}, //全部规格数据
                format_index: '', //当前选中的规格index
                selectFormat: [], //选中规格信息
                tableData: [], //表格数据信息
                formatClass: [], //当前选中的规格数据class
                table_top: [], //表头数据
                store_goods_unit_list:[],//单位列表
                temp_goods_cat_id:[],
                editRules: { // 表单验证规则

                    name: [{
                        required: true,
                        message: '请输入商品名称',
                        trigger: 'blur'
                    }],


                    thumbnail_pic: [{
                        required: true,
                        message: '请上传缩略图',
                        trigger: 'blur'
                    }],


                    images: [{
                        required: true,
                        message: '请上传相册',
                        trigger: 'blur'
                    }],



                    create_time: [{
                        required: true,
                        message: '请选择创建时间',
                        trigger: 'blur'
                    }],

                    address: [{
                        required: true,
                        message: '请输入原产地',
                        trigger: 'blur'
                    }],


                    brief: [{
                        required: true,
                        message: '请输入商品简介',
                        trigger: 'blur'
                    }],


                    info: [{
                        required: true,
                        message: '请输入详情',
                        trigger: 'blur'
                    }],


                    goods_cat_id: [{
                        required: true,
                        message: '请选择分类ID',
                        trigger: 'blur'
                    }],


                    is_recommend: [{
                        required: true,
                        message: '请选择推荐',
                        trigger: 'blur'
                    }],


                    is_hot: [{
                        required: true,
                        message: '请选择热门',
                        trigger: 'blur'
                    }],


                    new_product: [{
                        required: true,
                        message: '请选择新品',
                        trigger: 'blur'
                    }],


                    shop_id: [{
                        required: true,
                        message: '请选择店铺ID',
                        trigger: 'blur'
                    }],


                    stock: [{
                        required: true,
                        message: '请输入库存',
                        trigger: 'blur'
                    }],


                    price: [{
                        required: true,
                        message: '请输入单价',
                        trigger: 'blur'
                    }],


                    costprice: [{
                        required: true,
                        message: '请输入成本价',
                        trigger: 'blur'
                    }],



                    initial: [{
                        required: true,
                        message: '请输入起订数量',
                        trigger: 'blur'
                    }],
                    industry_id:[{
                        required: true,
                        message: '请选择行业',
                        trigger: 'blur'
                    }],
                    fare_type:[{
                        required: true,
                        message: '请选择行业',
                        trigger: 'blur'
                    }],
                },
            }
        },
        computed: {
            ...mapGetters(["permission"]),
            initEditor() {
                return {
                    height: 400,
                    file_picker_callback: this.file_picker_callback,
                    skin_url: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' :
                        '/tinymce/skins/ui/oxide',
                    content_css: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/content/dark/content.css' :
                        '/tinymce/skins/content/default/content.css',
                    images_upload_handler: (blobInfo, success, error) => {
                        let file = blobInfo.blob();
                        // 使用axios上传
                        const formData = new FormData();
                        formData.append('file', file, file.name);
                        this.$http.post('/upload/uploadImage', formData).then(res => {
                            if (res.data.code == 0) {
                                success(res.data.data);
                            } else {
                                error(res.data.msg);
                            }
                        }).catch(e => {
                            error(e.message);
                        });
                    }
                };
            },
            // 计算规格
            calculateAttribute() {
                // 初始化
                let obj = {}
                this.privateGoodsItem.forEach((item) => {
                    // 判断有没有输入规格名
                    if (item.privateSpecName) {
                        //规格名:规格值     //'颜色':'尺寸'
                        obj[item.privateSpecName] = item.dynamicTags
                    }
                })
                return obj
            }
        },
        watch: {
            
           
            // 监听规格数据
            calculateAttribute(newVal) {
                if (this.tableColumnList.status) {
                    this.tableColumnList.status = false;
                } else {
                    let cloneNewVal = JSON.parse(JSON.stringify(newVal))
                    let attrName = [] //规格名数组
                    let attrValue = [] //规格值数组
                    for (let key in cloneNewVal) {
                        attrName.push(key)
                        attrValue.push(cloneNewVal[key])
                    }

                    // 表格内容数据（笛卡尔积算法）
                    let finalArr = this.cartesianProductOf(...attrValue)

                    let tableObj = {
                        tableBodyList: [],
                        tableHeaderList: []
                    }
                    // 表格内容
                    tableObj.tableBodyList = finalArr.map((item) => {
                        let obj = {
                            sku_price: '',
                            sku_costprice: '',
                            sku_mktprice: '',
                            sku_stock: '',
                            sku_initial: 1,
                            image: '',
                        }
                        for (let i = 0; i < item.length; i++) {
                            obj[attrName[i]] = item[i]
                        }
                        return obj
                    })

                    this.tableColumnList.tableBodyList = tableObj.tableBodyList //表格内容数据

                    // 表头
                    let skuTableArr = Object.keys(newVal)
                    tableObj.tableHeaderList = skuTableArr.map((item) => {
                        return {
                            prop: item,
                            propName: item
                        }
                    })
                    this.tableColumnList.tableHeaderList = tableObj.tableHeaderList // 表头
                }


            }
        },
        mounted() {
            // this.storeGoodsCatAllList();
            this.storeGoodsCatFirstAllList();
        
            this.storeShopManagementAllList();
            //获取物流
            this.logisticsFareAllList();
            //获取单位
            this.storeGoodsUnitAllList();
        },
        methods: {
            /* 选择店铺*/
            shopChange(e){
                let id = [];
                for(var a in this.store_shop_management_list){
                    if(e == this.store_shop_management_list[a].id){
                        id = this.store_shop_management_list[a].temp_industry_id
                        id = JSON.parse(id);
                        id = id.map(arr => arr.join(',')).join();
                    }
                }
                console.log(id)
                // industry_ids
                //获取行业
                this.storeIndustryAllList(id);
            },
            /* 监听物流信息*/
            fareTypeChange(e){
                this.fare_status = false;
                for(var item in e){
                    if(e[item] == 1){
                        this.fare_status = true;
                    }
                }
            },
            /* 下一步*/
            nextTo(){
                this.$refs['editForm'].validateField(['shop_id','industry_id'],(valid) => {
                    console.log(valid)
                    if(this.editForm.shop_id && this.editForm.industry_id){
                        this.active_tab = 1;
                        this.formatAllInfo();
                    }
                });
            },
            /* 删除参数*/
            deleteParameter(index){
                this.editForm.parameter.splice(index,1);
            },
            /* 添加参数*/
            addParameter(){
                let data = {
                    name:'',
                    value:''
                }
                this.editForm.parameter.push(data)
            },
            handleCheckedCitiesChange(e, index, item) {
                // 添加数据
                if (e) {
                    this.privateGoodsItem[index].dynamicTags.push(item.name);
                } else {
                    for (var i = 0; i < this.privateGoodsItem[index].dynamicTags.length; i++) {
                        if (this.privateGoodsItem[index].dynamicTags[i] == item.name) {
                            this.privateGoodsItem[index].dynamicTags.splice(i, 1);
                            break;
                        }
                    }
                }
            },
            /* 
             * 选择规格
             */
            changeFormat(e) {
                if (e === '') {
                    this.tableColumnList = {};
                    this.privateGoodsItem = [];
                    this.formatClass = [];
                    this.checked_sku_info = [];
                } else {
                    this.checked_sku_info = [];
                    this.tableColumnList = {};
                    this.privateGoodsItem = [];
                    for (var i = 0; i < this.formatInfo.length; i++) {
                        if (this.formatInfo[i].id == e) {
                            this.format_index = i;
                            this.formatClass = this.formatInfo[i].children;
                            for (var k = 0; k < this.formatInfo[i].children.length; k++) {
                                var temp_info = {
                                    privateSpecName: this.formatInfo[i].children[k].name, //规格名
                                    dynamicTags: [], //规格值数组
                                    inputVisible: false,
                                    inputValue: ''
                                }
                                this.privateGoodsItem.push(temp_info);
                            }
                            break;
                        }
                    }

                }
            },
            // 笛卡尔积算法
            cartesianProductOf(...args) {
                return args.reduce(
                    (total, current) => {
                        let ret = []
                        total.forEach((a) => {
                            current.forEach((b) => {
                                ret.push(a.concat([b]))
                            })
                        })
                        return ret
                    },
                    [
                        []
                    ]
                )
            },
            /**
             * 获取规格分类
             */
            formatAllInfo() {
                if(this.editForm.industry_id.length>0){
                    let industry_id = this.editForm.industry_id[this.editForm.industry_id.length-1];
                    this.$http.get('/store/storeGoodsFormat/allList',{industry_id:industry_id}).then(res => {
                        if (res.data.code === 0) {
                            this.formatInfo = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                }
                
            },
            /**
             * 关闭
             */
            closeDialog() {
                this.showEdit = false;
                this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
            },
            /**
             * 显示编辑
             */
            edit(row) {
                this.$http.get('/store/storeGoods/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.showEdit = true;
                        setTimeout(() => {
                            this.editForm = res.data.data;
                            if (this.editForm.tableColumnList) {
                                this.editForm.tableColumnList.status = true;
                                this.tableColumnList = this.editForm.tableColumnList || [];
                                this.privateGoodsItem = this.editForm.privateGoodsItem || [];
                                this.checked_sku_info = this.editForm.checked_sku_info || [];
                                for (var i = 0; i < this.formatInfo.length; i++) {
                                    if (this.formatInfo[i].id == this.editForm.format_id) {
                                        this.format_index = i;
                                        this.formatClass = this.formatInfo[i].children;
                                        break;
                                    }
                                }
                            }
                            // console.log(this.privateGoodsItem);
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        if (this.privateGoodsItem.length > 0) {
                            this.editForm.tableColumnList = this.tableColumnList;
                            this.editForm.privateGoodsItem = this.privateGoodsItem;
                            this.editForm.checked_sku_info = this.checked_sku_info;
                        }
                        const loading = this.$loading({
                            lock: true
                        });
                        // tableColumnList: {
                        //     tableHeaderList: [],
                        //     tableBodyList: []
                        //     // inventory: ''
                        // },
                        // privateGoodsItem: [{
                        //     privateSpecName: '', //规格名
                        //     dynamicTags: [], //规格值数组
                        //     inputVisible: false,
                        //     inputValue: ''
                        // }],
                        //修改分类
                        let goods_cat_ids = [];
                        for(var i = 0;i<this.temp_goods_cat_id.length;i++){
                            goods_cat_ids.push(this.temp_goods_cat_id[i][this.temp_goods_cat_id[i].length-1])
                        }
                        this.editForm.goods_cat_ids = goods_cat_ids;
                        this.editForm.activity_status = 0;
                        this.editForm.temp_goods_cat_id = JSON.stringify(this.temp_goods_cat_id);
                        this.editForm.parameter = JSON.stringify(this.editForm.parameter);
                        this.$http.post('/store/storeGoods/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.editForm = {
                                    "thumbnail_pic": [],
                                    "images": [],
                                    fare_type:['1','2','3'],
                                    stock_reduce:'1',
                                    after_service:['1','2','3'],
                                    comment_status:'1',
                                    parameter:[],//参数数据.
                                    face_status:'2',
                                    unit:''
                                } // 表单数据
                                this.temp_goods_cat_id = [];
                                this.formatClass = '';
                                this.active_tab = 0;
                                this.tableColumnList = {}; 
                                this.formatClass = [];
                                this.formatInfo = [];
                                this.checked_sku_info = [];
                                this.options = [];
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的商品管理吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/store/storeGoods/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/store/storeGoods/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },

            /* 导出数据Excel */
            exportExcel() {
                let ids  = this.choose.map(d => d.id)
                if(ids.length == 0){
                    this.$message.error('请选择要导出的数据');
                    return false;
                }
                this.$http
                    .post("/user/UserMail/exportExcel", {id:ids})
                    .then((res) => {
                        let data = res.data;
                        if (data.code == 0) {
                            // 下载文件
                            window.location.href = data.data;
                            this.$message({
                                type: "success",
                                message: "导出成功",
                            });
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
            },
            //获取物流信息
            logisticsFareAllList(){
                this.$http.post('/logistics/logisticsFare/allList').then(res => {
                    if (res.data.code === 0) {
                        this.logistics_fare_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            //查询其他信息
            storeGoodsCatFirstAllList() {
                this.$http.post('/store/storeGoodsCat/allList').then(res => {
                    if (res.data.code === 0) {
                        this.store_goods_cat_list_first = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            //查询其他信息
            storeGoodsCatAllList(e) {
                this.$http.post('/store/storeGoodsCat/allList', {
                    parent_id: e
                }).then(res => {
                    if (res.data.code === 0) {
                        this.store_goods_cat_list = res.data.data;
                        this.$set(this.editForm, 'goods_cat_id', '');
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            //选择
            selectGoodsCatId(e) {
                this.storeGoodsCatAllList(e);
            },
            /* 获取单位*/
            storeGoodsUnitAllList(){
                this.$http.post('/store/storeGoodsUnit/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.store_goods_unit_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            //查询其他信息
            storeShopManagementAllList() {
                this.$http.post('/store/storeShopManagement/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.store_shop_management_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /* 新增*/
            storeIndustryAllList(id){
                this.$http.post('/store/storeIndustry/allList',{id:id}).then(res => {
                    if (res.data.code === 0) {
                        this.showEdit = true;
                        setTimeout(() => {
                            this.options = res.data.data;
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },

            /**
             * 更改状态
             */
            editStatus(row, name) {
                const loading = this.$loading({
                    lock: true
                });
                let data = {
                    id: row.id,
                    name: name,
                    value: row[name],
                }
                this.$http.post("/store/storeGoods/status", data).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        });
                    } else {
                        row[name] = !row[name] ? 1 : 0;
                        this.$message.error(res.data.msg);

                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
            },
        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }

    .ikz-sku {
        display: flex;
        align-items: center;
    }

    .ikz-checkbox-box-item {
        display: initial;
        margin-right: 10px;
    }
    
    .demo-input-suffix{
        display: flex;
        align-items: center;
    }
</style>
